<template>
  <el-dialog
    title="添加联合体"
    :visible.sync="showDialog"
    :close-on-click-modal="false"
    :before-close="closeDialog"
    class="dialog accept-invitation-dialog"
    width="700px"
  >
    <el-table
      class="m-t-10"
      :data="comboCompanyList"
      size="medium"
      border
      max-height="250"
    >
      <el-table-column
        label="序号"
        prop="index"
        align="center"
        type="index"
        width="60"
      />
      <el-table-column label="联合体成员名称" align="center" min-width="100">
        <template slot-scope="{ row }">
          <el-input
            v-model="row.name"
            placeholder="请输入联合体成员名称"
            maxlength="100"
          />
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="160"
        show-overflow-tooltip
      >
        <template slot-scope="{ $index }">
          <el-button
            type="text"
            class="danger-button"
            @click="deleteComboCompany($index)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="table-btn flex-center" @click="addComboCompany()">
      <i class="el-icon-plus"></i> 添加联合体成员
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button size="medium" @click="closeDialog()">取 消</el-button>
      <el-button
        type="primary"
        size="medium"
        @click="submit()"
      >确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { cloneDeep } from 'lodash'

export default {
  data() {
    return {
      showDialog: false,
      comboCompanyList: [],
      index: ''
    }
  },
  methods: {
    /**
     * 关闭弹窗
     */
    closeDialog() {
      this.showDialog = false
      this.comboCompanyList = []
      this.index = ''
    },

    /**
     * 打开弹窗
     */
    open(data, index) {
      this.showDialog = true
      this.comboCompanyList = cloneDeep(data || []).map(el => ({ name: el }))
      this.index = index
    },

    /**
     * 手动联合体公司
     */
    addComboCompany() {
      this.comboCompanyList.push({
        canEdit: true,
        name: ''
      })
    },

    /**
     * 删除联合体公司
     */
    deleteComboCompany(index) {
      this.comboCompanyList.splice(index, 1)
    },

    /**
     * 提交
     */
    submit() {
      const _valid = this.comboCompanyList.every(el => !!el.name)
      if (!_valid) {
        this.$message.warning('请先填写完整联合体')
        return
      }
      this.$emit('setComboList', {
        list: this.comboCompanyList || [],
        index: this.index
      })
      this.closeDialog()
    }
  }
}
</script>
<style lang="scss" scoped>
.table-btn {
  height: pixel-to-rem($n: 60);
  background-color: $primary-background-color;
  color: $primary-color;
  @include text-bold;
  font-size: 16px;
  cursor: pointer;

  i {
    @include text-bold;;
    font-size: 16px;
    margin-right: 8px;
    padding-top: 1px;
  }
}
</style>
